import NotesNewContainer from './notes_new_container';

const NotesNew = NotesNewContainer;
export default NotesNew;
